import { useCallback } from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import i18n from '@signavio/i18n';
import { Divider, LegacyButton as Button, Popover, Title2, useStyles } from '@signavio/ui';
import { Hint } from './hints';
import { TextTile } from './tiles';
import { loggerService } from '../services/logger';
import ErrorDetails from './ErrorDetails';
import { useNavigate } from '../hooks/useNavigate';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function ErrorBoundary({
  children,
  asTile,
  small,
  transparent,
  logger = loggerService,
  style: styleProp
}) {
  const styles = useStyles(defaultStyles, {
    style: styleProp
  });
  const {
    navigate
  } = useNavigate();
  const onError = useCallback((error, info) => {
    logger.sendError(error, info);
  }, [logger]);
  const FallbackComponent = useCallback(({
    error
  }) => {
    if (asTile) {
      return /*#__PURE__*/_jsx(Popover, {
        popover: /*#__PURE__*/_jsx(ErrorDetails, {
          debug: true,
          children: /*#__PURE__*/_jsx("pre", {
            ...styles('error'),
            children: `${error.name || 'Error'}: ${error.message}`
          })
        }),
        children: /*#__PURE__*/_jsx(TextTile, {
          small,
          transparent,
          children: /*#__PURE__*/_jsx(Hint, {
            danger: true,
            small: small,
            inline: true,
            children: i18n('Something went wrong')
          })
        })
      });
    }
    return /*#__PURE__*/_jsx(Hint, {
      danger: true,
      children: /*#__PURE__*/_jsxs("div", {
        ...styles('content'),
        children: [/*#__PURE__*/_jsx(Title2, {
          children: i18n('Oops, something went wrong!')
        }), /*#__PURE__*/_jsx(ErrorDetails, {
          debug: true,
          children: /*#__PURE__*/_jsx("pre", {
            ...styles('error'),
            children: `${error.name || 'Error'}: ${error.message}`
          })
        }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(Button, {
          primary: true,
          icon: "refresh",
          onClick: () => navigate(0),
          children: i18n('Reload application')
        })]
      })
    });
  }, [asTile, small, transparent, styles, navigate]);
  return /*#__PURE__*/_jsx(ReactErrorBoundary, {
    FallbackComponent: FallbackComponent,
    onError: onError,
    children: children
  });
}
const defaultStyles = {
  content: {
    fontStyle: 'normal'
  },
  error: {
    whiteSpace: 'pre-wrap'
  }
};
export default ErrorBoundary;